import instance from '../lib/axios'

const PATH = '/administrators'

export const postAdministrators = (data: {name: string; nickname: string; password: string}) =>
  instance({method: 'post', url: PATH, data})

export const getAdministrators = (params: {start: number; perPage: number; search?: string}) =>
  instance({method: 'get', url: PATH, params})

export const getAdministrator = (id: number | string) => instance({method: 'get', url: PATH + '/' + id})

export const patchAdministrator = (
  id: number | string,
  data: {
    name?: string
    nickname?: string
    password?: string
  }
) => instance({method: 'patch', url: PATH + '/' + id, data})

export const deleteAdministrators = (id: number | string) => instance({method: 'delete', url: PATH + '/' + id})
